export enum UserTableColumns {
  ENGLISH_NAME = "English Name",
  ARABIC_NAME = "Arabic Name",
  NATIONALITY = "Nationality",
  PASSPORT = "Passport #",
  UNIFIED_ID = "Unified ID",
  EMIRATES_ID = "Emirates ID",
  HSE = "HSE",
  ANNUAL_MEDICAL_CHECK = "Annual Medical Check",
  TOXIC_GAS = "Toxic Gas",
}

export const DEFAULT_CHUNK_SIZE = 10;

export const UsersOnboardingStatuses = ["Not Completed", "Completed"];
